<template>
  <el-dialog
    :visible.sync="dialogVisible"
    custom-class="online-project-report-edit-dialog"
    :modal="true"
    append-to-body
    :close-on-click-modal="false"
    :show-close="false"
    :width="'80%'"
  >
    <div style="margin-bottom:10px; width: 100%;">
      <el-row v-if="type === 'projectProposal'" style="margin-bottom:10px;">
        <el-col :span="4"><span class="main-title">项目建议书:</span></el-col>
        <el-col :span="18"
          ><span class="info"
            >项目建议书为新建项目成功后和客户汇报阿尔法对于该岗位的情况，以及需要反复和客户确认的问题话术，以下数据为系统根据项目信息自动生成，客户经理可以酌情自行修改，然后点击导出报告导入到自己的电脑。</span
          ></el-col
        >
      </el-row>
      <el-row v-if="type === 'projectSearchReport'" style="margin-bottom:10px;">
        <el-col :span="4"><span class="main-title">推荐人选汇总:</span></el-col>
        <el-col :span="18"
          ><span class="info"
            >客户经理使用该报告和客户盘候选人时使用；数据为在项目中推荐阶段往后的人选，以下数据为系统根据项目信息自动生成，客户经理可酌情自行修改，然后点击导出报告，下载到自己的电脑。</span
          ></el-col
        >
      </el-row>
      <el-row style="margin-bottom:10px;">
        <el-col :span="4"
          ><span class="sub-title">客户经理:</span><span class="info">{{ manager }}</span></el-col
        >
        <el-col :span="4"
          ><span class="sub-title">项目对接:</span><span class="info">{{ duijie }}</span></el-col
        >
      </el-row>
      <el-card style="height: 65vh;">
        <div v-show="md5" id="projectProposalEditor1" style="height:65vh !important"></div>
      </el-card>
      <span slot="footer">
        <div style="margin-left: 65vw;margin-top: 10px;">
          <el-button plain size="small" @click="cancleEdit">取消2</el-button>
          <el-button type="primary" size="small" @click="saveReport">导出报告</el-button>
        </div>
      </span>
    </div>
  </el-dialog>
</template>
<script>
// import WPSOfficeSDK from '../../../../assets/weboffice/web-office-sdk-v1.1.2.es'
// import WPSOfficeSDK from '../../../../assets/weboffice/web-office-sdk-v1.1.2.es'

const { download } = require('../../constant/utils')

export default {
  props: {
    type: { type: String, default: 'projectSearchReport' },
  },
  data() {
    return {
      dialogVisible: false,
      manager: '',
      duijie: '',
      projectId: '',
      previewUrl: '',
      config: {
        document: {
          fileType: 'docx',
          key: '',
          title: '',
          url: '',
        },
        documentType: 'word',
        editorConfig: {
          actionLink: null,
          callbackUrl: `${window.host}/track`,
          coEditing: null,
          createUrl: null,
          customization: {
            about: false,
            autosave: true,
            comments: false,
            feedback: false,
            // forcesave: false,
            submitForm: false,
            compactHeader: false,
            compactToolbar: false,
            toolbarNoTabs: false,
            hideRightMenu: true,
            hideRulers: true,
            // zoom: -2,
            features: {
              spellcheck: false,
            },
            integrationMode: 'embed',
            logo: {
              image: 'https://alphahr.oss-cn-beijing.aliyuncs.com/public/assets/alpha-logo.png',
            },
            review: false,
          },
          user: {
            group: '',
            id: app.user._id,
            name: app.user.account || 'test',
          },
          region: 'zh-CN',
          lang: 'zh-CN',
          plugins: false,
        },
        mode: 'edit',
        height: '100%',
        width: '100%',
        type: 'desktop',
      },
      originalname: '',
      documentType: 'word',
      fileType: 'docx',
      md5: '',
      docEditor: null,
    }
  },
  computed: {
    download() {
      return download
    },
  },
  mounted() {
    this.config.events = {
      onError: this.destoryEditor,
      onRequestClose: this.destoryEditor,
    }
  },
  methods: {
    async open({ url, md5, manager, duijie, projectId, documentType, fileType, originalname }) {
      console.log('🚀 ~ file: ProjectReportEditor.vue:134 ~ open ~ url:', url)
      this.dialogVisible = true
      this.previewUrl = url
      this.md5 = md5
      this.manager = manager
      this.duijie = duijie
      this.projectId = projectId
      this.config.documentType = documentType
      this.config.document.fileType = fileType
      this.config.document.key = `${this.md5}-${Date.now()}`
      this.config.document.title = originalname
      this.config.document.url = url
      this.$nextTick(async () => {
        if (!this.docEditor) {
          this.docEditor = new window.DocsAPI.DocEditor('projectProposalEditor1', this.config)
        }
      })
    },
    async saveReport() {
      const text =
        this.type === 'projectProposal' ? '正在导出项目建议书，请稍等...' : '正在导出推荐人选汇总报告，请稍等...'
      const loading = this.$loading({
        lock: true,
        text,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.destoryEditor()
      try {
        await this.sleep(10000)
        const res = await app.service('file').downloadOnlyOfficeFile({ md5: this.md5 })
        if (res && res.data) {
          try {
            await app
              .service('project')
              .insertProjectFile([Object.assign({}, res.data, { type: '项目报告', projectId: this.projectId })])
          } catch (err) {
            console.error(err)
          }
          download({ md5: res.data.md5 })
          this.dialogVisible = false
          this.$emit('confirm')
        }
      } catch (e) {
        this.$message.error(`导出报告出错，请联系管理员`)
      }
      loading.close()
    },
    async sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    cancleEdit() {
      this.destoryEditor()
      this.dialogVisible = false
      this.$emit('cancle')
    },
    destoryEditor() {
      this.docEditor && this.docEditor.destroyEditor()
      this.docEditor = null
    },
  },
}
</script>
<style>
.online-project-report-edit-dialog {
  margin-top: 8vh !important;
}
.online-project-report-edit-dialog .el-dialog__header {
  padding: 0px !important;
}
.online-project-report-edit-dialog .el-card__body {
  height: 64vh !important;
  padding: 0px !important;
}
.online-project-report-edit-dialog .el-dialog__body {
  padding: 10px 20px !important;
}
.online-project-report-edit-dialog .main-title {
  font-size: 18px;
  color: #9e9ea7;
}
.online-project-report-edit-dialog .sub-title {
  color: #9e9ea7;
}
</style>
